module.exports = __webpack_public_path__ + "static/media/woman.dbe3845e.svg";